import React from 'react';
import Component from '@vfuk/core-radio-button-list';
const RadioButtonList = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default RadioButtonList;
